import React from "react";
import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={classes.footer}>
      <h1>Built and deployed</h1>
      <h3>By</h3>
      <h1>IFEANYI EZEUGWU</h1>
    </div>
  );
};

export default Footer;
